import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { PmIconComponent } from '../pm-icon/pm-icon.component';

@Component({
  standalone: true,
  selector: 'pm-error-message',
  imports: [PmIconComponent, CommonModule],
  templateUrl: './pm-error-message.component.html',
  styleUrl: './pm-error-message.component.scss',
})
export class PmErrorMessageComponent {
  @Input() message = $localize`Wystąpił błąd`;
  @Input() pageError = false;

  @HostBinding('class.page-error') get isFullWidth() {
    return this.pageError;
  }
}
